import * as React from "react";
const SvgBulletOrange = (props) => /* @__PURE__ */ React.createElement("svg", { width: 5, height: 6, viewBox: "0 0 5 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 2.5, cy: 3, r: 2.5, fill: "#E26F08" }));
export default SvgBulletOrange;
